@if(!field()){
<code>...Loading</code>
}
@else{

<div class="mat-mdc-form-field" role="group" [attr.aria-labelledby]="field().fieldId.toString() + '-label'">
  <!-- Use an explicit labelled element so assistive tech can reference it -->
  <label id="{{field().fieldId}}-label">{{ label }}</label>
  <mat-radio-group role="radiogroup"
                   [id]="field().fieldId.toString()"
                   [formControl]="formControl"
                   [attr.aria-labelledby]="field().fieldId.toString() + '-label'"
                   [attr.aria-invalid]="formControl.invalid ? 'true' : 'false'">
    @for (option of options; track option) {
    <mat-radio-button [value]="option.value">{{option.displayText}}</mat-radio-button>
    }
  </mat-radio-group>
  <div class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align">
    <div aria-atomic="true" aria-live="polite" class="mat-mdc-form-field-error-wrapper">
      @if(formControl.errors?.['required']){
      <mat-error [attr.id]="field().fieldId.toString() + '-error'" aria-live="assertive">{{ label }} is <strong>required</strong></mat-error>
      }
      @if(formControl.errors?.['custom']){
      <mat-error [attr.id]="field().fieldId.toString() + '-error'" aria-live="assertive">{{ label }} can only be specified <strong>once</strong></mat-error>
      }
    </div>
  </div>
</div>
}
